import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export default function HealthGuide() {
  const navigate = useNavigate();
  const [HEALTH_GUIDES, setGuides] = useState([]);
  useEffect(() => {
    api.get("/guides").then((r) => setGuides(r.data.filter((g) => g.active !== false))).catch(() => {});
  }, []);
  return (
    <div className="animate-fade-in">
      <div className="px-5 pt-4 pb-3">
        <span className="text-[11px] font-semibold tracking-wider uppercase text-emerald-600 dark:text-emerald-400">Free Guidance</span>
        <h1 className="text-2xl font-extrabold text-emerald-950 dark:text-emerald-50 font-head">Health & Diet Guide</h1>
        <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">Evidence-based diets for common conditions</p>
      </div>

      <div className="px-4 grid grid-cols-2 gap-3 pb-4">
        {HEALTH_GUIDES.map((g) => {
          const Icon = Icons[g.icon] || Icons.HeartPulse;
          return (
            <button
              key={g.id}
              data-testid={`guide-card-${g.id}`}
              onClick={() => navigate(`/guide/${g.id}`)}
              className="text-left p-4 rounded-2xl bg-white dark:bg-emerald-900/60 border border-slate-100 dark:border-emerald-800 active:scale-[0.98] transition flex flex-col"
            >
              <div className="w-12 h-12 rounded-2xl bg-emerald-100 dark:bg-emerald-800 flex items-center justify-center mb-3">
                <Icon className="w-6 h-6 text-emerald-700 dark:text-emerald-300" />
              </div>
              <p className="font-bold text-sm text-emerald-950 dark:text-emerald-50 leading-snug">{g.title}</p>
              <p className="text-xs text-slate-500 dark:text-slate-400 mt-1 line-clamp-2 flex-1">{g.description}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-bold text-emerald-600 dark:text-emerald-400">
                Read Guidelines <ArrowRight className="w-3.5 h-3.5" />
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
